import {
  BAR_NAME_FONT_SIZE,
  BAR_NAME_LINE_HEIGHT,
  BAR_NAME_OFFSET,
  INK,
} from './chuva-chart-constants';
import { wrapLabel } from './chuva-chart-utils';

interface BarLabelProps {
  x?: number | string;
  y?: number | string;
  value?: number | string;
}

const createBarNameLabel = (maxChars: number) => {
  const BarNameLabel = ({ x = 0, y = 0, value }: BarLabelProps) => {
    const label = String(value ?? '').toUpperCase();
    const lines = wrapLabel(label, maxChars);
    const firstLineY =
      Number(y) - BAR_NAME_OFFSET - (lines.length - 1) * BAR_NAME_LINE_HEIGHT;
    return (
      <text
        fill={INK}
        fontSize={BAR_NAME_FONT_SIZE}
        fontWeight={600}
        textAnchor="start"
        x={Number(x)}
        y={firstLineY}
      >
        <title>{label}</title>
        {lines.map((line, index) => (
          <tspan
            key={line}
            dy={index === 0 ? 0 : BAR_NAME_LINE_HEIGHT}
            x={Number(x)}
          >
            {line}
          </tspan>
        ))}
      </text>
    );
  };
  BarNameLabel.displayName = 'BarNameLabel';
  return BarNameLabel;
};

export default createBarNameLabel;
